import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#066542",
      d: "M4.14 18.259V6.025A3.025 3.025 0 0 1 7.166 3h11.949a.75.75 0 0 1 .75.75v12.518a.75.75 0 0 1-1.5 0V4.5h-11.2c-.842 0-1.525.683-1.525 1.525V18.26a.75.75 0 0 1-1.5 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#066542",
      d: "M19.115 15.517a.75.75 0 0 1 .596 1.204c-.242.32-.422.874-.433 1.504-.011.628.147 1.2.43 1.568A.75.75 0 0 1 19.115 21H6.88a2.74 2.74 0 1 1 0-5.483zM5.64 18.26c0 .686.556 1.24 1.241 1.24h11.054a4.7 4.7 0 0 1-.157-1.3c.007-.395.064-.798.17-1.182H6.88c-.685 0-1.24.556-1.24 1.242M14.277 4.034H9.725v5.121a.569.569 0 0 0 .972.403L12 8.254l1.304 1.304a.568.568 0 0 0 .972-.403z"
    }, null, -1)
  ]))]))
}
export default { render: render }